const currentDate = new Date();
export const currentYear = currentDate.getFullYear();
export const currentMonth = currentDate.getMonth() + 1;

export const validateMonth = (month: string): boolean => {
  if (month) {
    // month can be one 0 to support leading 0s ie: 0 -> 05/
    if (month === "00") {
      return false;
    }
    const monthAsInt = parseInt(month, 10);
    return monthAsInt >= 0 && monthAsInt <= 12;
  } else {
    return true;
  }
};

export const validateYear = (year: string) => {
  if (year) {
    const yearAsInt = parseInt(year, 10);
    return !Number.isNaN(yearAsInt) && year.length <= 2;
  } else {
    return true;
  }
};

export const validateFullYear = (year: string) => {
  if (year) {
    const yearAsInt = parseInt(year);
    return !Number.isNaN(yearAsInt) && yearAsInt >= currentYear;
  } else {
    return true;
  }
};

const validateSlashes = (value: string) => {
  const slashCounter = value.match(/\//g);
  return slashCounter ? slashCounter.length === 1 : false;
};

export const validateExpiration = (value: string) => {
  if (!value) {
    return true;
  }
  if (!validateSlashes(value)) {
    return false;
  }

  // When user types in the expiry it comes in the format `MM / YY` but when pasted in it comes in as `MM/YY`
  const [month, year] =
    value.indexOf(" / ") > -1 ? value.split(" / ") : value.split("/");
  return validateMonth(month) && validateYear(year);
};

export const validateExpirationForCurrentYear = (
  valueOne: string,
  valueTwo: string
) => {
  const valueOneAsInt = parseInt(valueOne);
  const valueTwoAsInt = parseInt(valueTwo);

  const month = Math.min(valueOneAsInt, valueTwoAsInt);
  const year = Math.max(valueOneAsInt, valueTwoAsInt);

  if (currentYear < year) {
    return true;
  }

  return currentYear === year && currentMonth <= month;
};

export const validateExpirationInFuture = (value: string) => {
  if (!value) {
    return true;
  }
  // When user types in the expiry it comes in the format `MM / YY` but when pasted in it comes in as `MM/YY`
  const [month, year] =
    value.indexOf(" / ") > -1 ? value.split(" / ") : value.split("/");
  const now = new Date();
  // add value to most recent century since value is expressed as 2 digits
  // ie: value is "25" + Math.floor(2022 / 100) * 100 = 25 + 20 * 100 = 2025
  const yearAsInt =
    parseInt(year, 10) + Math.floor(now.getFullYear() / 100) * 100;

  // Date() monthIndex is passed through as 0-11, instead of 1-12.
  // We do not change to monthIndex as we want it to pass through as the 1st of the following month
  // e.g. - user passes 01/24 (January 2024), new Date() will return February 01 2023 00:00:00
  // this is the true expiry time as expiry can be up till the last minute of the expiry month
  const monthAsInt = parseInt(month, 10);

  if (monthAsInt <= 0 || monthAsInt > 12) {
    return false;
  }

  const expirationAsDate = new Date(yearAsInt, monthAsInt);

  return now < expirationAsDate;
};
